"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataCy = void 0;
exports["default"] = _default;
exports.defaultGetOptionValue = void 0;
var _react = require("react");
var _reactVirtualizedTree = _interopRequireWildcard(require("@gogame/react-virtualized-tree"));
var _NoResults = _interopRequireDefault(require("../NoResults/NoResults"));
var _RowItem = _interopRequireDefault(require("./RowItem"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var updateNode = _reactVirtualizedTree.selectors.updateNode;
var defaultGroupLabel = function defaultGroupLabel(_ref) {
  var name = _ref.name,
    children = _ref.children;
  return "".concat(name, " (").concat(children.length, ")");
};
var EMPTY_ARRAY = [];
var defaultGetOptionLabel = function defaultGetOptionLabel(_ref2) {
  var name = _ref2.name;
  return name;
};
var defaultGetOptionValue = exports.defaultGetOptionValue = function defaultGetOptionValue(_ref3) {
  var id = _ref3.id;
  return id;
};
var defaultIsDisabledCheckbox = function defaultIsDisabledCheckbox() {
  return false;
};
var dataCy = exports.dataCy = 'virtualized-list';
function _default(_ref4) {
  var _ref4$data = _ref4.data,
    data = _ref4$data === void 0 ? EMPTY_ARRAY : _ref4$data,
    _ref4$expandedIds = _ref4.expandedIds,
    expandedIds = _ref4$expandedIds === void 0 ? EMPTY_ARRAY : _ref4$expandedIds,
    _ref4$rowHeight = _ref4.rowHeight,
    rowHeight = _ref4$rowHeight === void 0 ? 48 : _ref4$rowHeight,
    actionCount = _ref4.actionCount,
    secondaryActionComponent = _ref4.secondaryAction,
    checkboxProp = _ref4.checkbox,
    defaultExpanded = _ref4.defaultExpanded,
    isExpanded = _ref4.isExpanded,
    iconComponent = _ref4.icon,
    button = _ref4.button,
    gutterLabel = _ref4.gutterLabel,
    isChecked = _ref4.isChecked,
    isSelected = _ref4.isSelected,
    _ref4$getOptionValue = _ref4.getOptionValue,
    getOptionValue = _ref4$getOptionValue === void 0 ? defaultGetOptionValue : _ref4$getOptionValue,
    _ref4$getOptionLabel = _ref4.getOptionLabel,
    getOptionLabel = _ref4$getOptionLabel === void 0 ? defaultGetOptionLabel : _ref4$getOptionLabel,
    _ref4$getGroupLabel = _ref4.getGroupLabel,
    getGroupLabel = _ref4$getGroupLabel === void 0 ? defaultGroupLabel : _ref4$getGroupLabel,
    getOptionSecondaryLabel = _ref4.getOptionSecondaryLabel,
    onItemClick = _ref4.onItemClick,
    _ref4$divider = _ref4.divider,
    divider = _ref4$divider === void 0 ? true : _ref4$divider,
    labelWrap = _ref4.labelWrap,
    withSearch = _ref4.withSearch,
    className = _ref4.className,
    _ref4$isDisabledCheck = _ref4.isDisabledCheckbox,
    isDisabledCheckbox = _ref4$isDisabledCheck === void 0 ? defaultIsDisabledCheckbox : _ref4$isDisabledCheck;
  var _useState = (0, _react.useState)(data.map(function (el) {
      return defaultExpanded ? _objectSpread(_objectSpread({}, el), {}, {
        state: {
          expanded: true
        }
      }) : el;
    })),
    _useState2 = _slicedToArray(_useState, 2),
    nodes = _useState2[0],
    setNodes = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isTreeData = _useState4[0],
    setTreeData = _useState4[1];
  var memoNodes = (0, _react.useMemo)(function () {
    return nodes;
  }, [JSON.stringify(nodes)]);
  var isExpandedRef = (0, _react.useRef)(null);
  isExpandedRef.current = isExpanded;
  (0, _react.useEffect)(function () {
    var newNodes = [];
    data.forEach(function (el) {
      var _isExpandedRef$curren;
      var groupExpanded = (_isExpandedRef$curren = isExpandedRef.current) === null || _isExpandedRef$curren === void 0 ? void 0 : _isExpandedRef$curren.call(isExpandedRef, el);
      newNodes.push(groupExpanded || defaultExpanded || expandedIds.includes(el.id) ? _objectSpread(_objectSpread({}, el), {}, {
        state: {
          expanded: true
        }
      }) : el);
      if (!isTreeData && !!(el !== null && el !== void 0 && el.children)) {
        setTreeData(true);
      }
    });
    setNodes(newNodes);
  }, [defaultExpanded, data, expandedIds, isTreeData]);
  var handleChange = function handleChange(nodess) {
    setNodes(nodess);
  };
  var renderRow = function renderRow(_ref5) {
    var _node$children;
    var node = _ref5.node,
      index = _ref5.index,
      style = _ref5.style,
      onChange = _ref5.onChange;
    var handleChange = function handleChange() {
      var _node$state;
      onChange(_objectSpread(_objectSpread({}, updateNode(node, {
        expanded: !((_node$state = node.state) !== null && _node$state !== void 0 && _node$state.expanded)
      })), {}, {
        index: index
      }));
    };
    var value = getOptionValue === null || getOptionValue === void 0 ? void 0 : getOptionValue(node);
    var _ref6 = (isChecked === null || isChecked === void 0 ? void 0 : isChecked(node, {
        value: value
      })) || false,
      checked = _ref6.checked,
      isAllChecked = _ref6.isAllChecked;
    var isGroupItem = !!node.children;
    var label = isGroupItem ? getGroupLabel(node) : getOptionLabel(node);
    var secondaryLabel = getOptionSecondaryLabel === null || getOptionSecondaryLabel === void 0 ? void 0 : getOptionSecondaryLabel(node);
    var secondaryAction = typeof secondaryActionComponent === 'function' ? secondaryActionComponent(node, {
      isGroupItem: isGroupItem,
      value: value
    }) : secondaryActionComponent;
    var icon = typeof iconComponent === 'function' ? iconComponent(node, {
      isGroupItem: isGroupItem
    }) : iconComponent;
    var selected = (isSelected === null || isSelected === void 0 ? void 0 : isSelected(node, {
      isGroupItem: isGroupItem,
      value: value
    })) || false;
    var handleClick = onItemClick ? function (e) {
      return onItemClick(e, node, {
        checked: checked,
        value: value
      });
    } : undefined;
    var checkbox = typeof checkboxProp === 'function' ? checkboxProp(node, {
      isGroupItem: isGroupItem,
      value: value
    }) : checkboxProp;
    var disabled = isDisabledCheckbox(node, {
      value: value,
      isGroupItem: isGroupItem
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RowItem["default"], {
      label: label,
      onChange: handleChange,
      rowHeight: rowHeight,
      style: _objectSpread(_objectSpread({}, style), {}, {
        cursor: button ? 'pointer' : 'default'
      }),
      className: className,
      secondaryAction: secondaryAction,
      actionCount: actionCount,
      checkbox: checkbox,
      checked: checked,
      secondaryLabel: secondaryLabel,
      state: node.state,
      isAllChecked: isAllChecked,
      groupItem: isGroupItem,
      count: node === null || node === void 0 || (_node$children = node.children) === null || _node$children === void 0 ? void 0 : _node$children.length,
      button: button,
      icon: icon,
      selected: selected,
      onItemClick: handleClick,
      gutterLabel: gutterLabel,
      divider: divider,
      labelWrap: labelWrap,
      isTreeData: isTreeData,
      disabled: disabled
    });
  };
  return memoNodes !== null && memoNodes !== void 0 && memoNodes.length ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactVirtualizedTree["default"], {
    nodes: memoNodes,
    onChange: handleChange,
    children: renderRow,
    "data-cy": dataCy
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoResults["default"], {
    inited: !!data,
    filtered: withSearch
  });
}